import type { I18n } from "@lingui/core";
import type { LocalizedMessage } from "../types";

/**
 * Resolves a LocalizedMessage to a translated string.
 * Translates resource names and main message using Lingui.
 * @param i18n - Lingui i18n instance
 * @param message - LocalizedMessage object with key and params
 * @returns Resolved message string with interpolated parameters
 */
export function resolveLocalizedMessage(
  i18n: I18n,
  message: LocalizedMessage | null | undefined,
): string {
  if (!message) return "";

  try {
    const params = { ...(message.params ?? {}) };

    // Translate resource label if present
    if (params.resourceKey && params.integrationKey) {
      const resourceId = `resource.${params.integrationKey}.${params.resourceKey}`;
      const translated = i18n._(resourceId as any);

      // If translation found (doesn't return the id itself), use it
      params.resource =
        translated !== resourceId ? translated : params.resourceKey;

      // Remove resourceKey since we're using resource instead
      delete params.resourceKey;
      delete params.integrationKey;
    }

    // Translate the main message
    return i18n._(message.key as any, params);
  } catch (error) {
    console.warn(
      `[resolveLocalizedMessage] Failed to translate "${message.key}":`,
      error,
    );
    return message.key; // Fallback to key if translation fails
  }
}
